module.exports = {};


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/$.iterators.js
// module id = 25
// module chunks = 2